import React from "react";
import CodropsDemo from "./components/DotShader";
import { NavButtons } from "./components/NavButtons";
import { Skills } from "./components/Skills";
// import Animation from "./animation";

export const App2 = () => {
  return (
    <div className="w-screen h-screen relative">
      {/* <p className="absolute flex items-start justify-center text-center w-full h-full bg-opacity-0 text-black z-10 lg:text-[100px] text-3xl leading-none font-raleway font-thin pointer-events-none drop-shadow-[0_1.3px_1.3px_rgba(255,255,255,1)] pt-16">
          MY TECHSTACK
        </p> */}
      {/* <div className="z-10 absolute top-[40px] left-[40px] font-[raleway] text-[12px] lg:text-[18px]">
        shreeramganeshan@gmail.com
      </div>
      <div className="z-10 absolute top-[40px] right-[40px] font-[raleway] text-[12px] lg:text-[18px]">
        Navi Mumbai, India
      </div> */}
      {/* <NavButtons type="skills" /> */}
      {/* <Animation /> */}
      <Skills />
      <CodropsDemo />
    </div>
  );
};
